import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteFromWantedFailed, deleteFromWantedSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteFromWanted(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/wanted-list`;
    const dataResponse = yield makeRequest(url, { ids: action.payload }, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deleteFromWantedSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteFromWantedFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteFromWantedFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
